'use client';

import type { DeviceType, PlatformType } from '@weberus/shared-types';
import { type PropsWithChildren } from 'react';
import { Provider } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import { deviceAtom, expGroupsAtom, appDeviceAtom, testProductAtom } from '@/app/_shared/store/device';

interface GlobalProviderProps extends PropsWithChildren {
  deviceType: DeviceType;
  platformType: PlatformType;
  appType?: DeviceType;
  expGroups: string | null;
  appDevice: 'ios' | 'android' | undefined;
  testProduct: 'NO' | 'YES' | 'ONLY' | null;
}

function StateWrapper({
  children,
  deviceType,
  platformType,
  appType,
  expGroups,
  appDevice,
  testProduct,
}: GlobalProviderProps) {
  useHydrateAtoms([
    [deviceAtom, { deviceType, platformType, appType: appType ?? null }],
    [expGroupsAtom, expGroups],
    [appDeviceAtom, appDevice],
    [testProductAtom, testProduct],
  ]);

  return <>{children}</>;
}

function GlobalProvider(props: GlobalProviderProps) {
  return (
    <Provider>
      <StateWrapper {...props} />
    </Provider>
  );
}

export default GlobalProvider;
